<ng-container *ngIf="notifications$ | async as notifications">
  <div class="l-notifications">
    <ng-container *ngFor="let item of notifications; let i = index; trackBy: trackByFn">
      <div class="l-notifications__item">
        <div [ngClass]="{ 'is-closing': item.class === 'is-closing' }" class="c-notification" [class]="'is-' + item.type">
          <div class="c-notification__content">
            <div class="c-notification__title">
              <strong [innerText]="getNotificationTitle(item.type)"></strong>
              {{ item.title }}
            </div>
            <ng-container *ngIf="item.content">
              <div class="c-notification__text">{{ item.content }}</div>
            </ng-container>
          </div>
          <div (click)="close(i)" class="c-notification__close"></div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
